import { render, staticRenderFns } from "./DetectionListUrlLayout.vue?vue&type=template&id=349c1b64&scoped=true"
import script from "./DetectionListUrlLayout.vue?vue&type=script&lang=js"
export * from "./DetectionListUrlLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "349c1b64",
  null
  
)

export default component.exports